document.addEventListener('DOMContentLoaded', () => {
  const productForm = document.querySelector('product-form, [data-product-form]');
  if (!productForm) return;

  productForm.addEventListener('product:variant-change', (event) => {
    const variant = event.detail.variant;
    if (!variant) return;

    if (variant.featured_media) return;

    const gallery = document.querySelector('[data-product-photos]');
    if (!gallery) return;

    const slides = gallery.querySelectorAll('[data-media-id]');
    if (!slides.length) return;

    slides.forEach(slide => {
      slide.removeAttribute('hidden');
      slide.classList.remove('is-hidden');
      slide.style.display = '';
    });

    const firstSlide = slides[0];
    if (firstSlide) firstSlide.classList.add('is-selected');

    // Dispatch standard variant change events for apps like Kbite
    document.dispatchEvent(new CustomEvent('variant:changed', {
      detail: { 
        variant: variant,
        available: variant.available 
      }
    }));

    document.dispatchEvent(new CustomEvent('variantChange', {
      detail: { 
        variant: variant,
        available: variant.available 
      }
    }));
  });
});
